<div class="container-fluid" [formGroup]="pageForm">
    <div id="enfant">
        <p class="texte-info-cnaf">Tous les champs sont obligatoires, sauf mention contraire.</p>

        <div class="col-sm-12" *ngFor="let enfant of enfants; let idx = index">
            <app-enfant
                name="enfant_{{idx}}"
                [codePostal]="codePostal"
                [enfant]="enfant"
                (enfantEvent)="dataEnfantChange($event, idx)">
            </app-enfant>
        </div>

    </div>

    <!-- Barre de bouton -->
    <div class="row row-btn-cnaf">
        <div class="col-sm-12 form-group margin-top-25">
            <app-bouton-quitter [pageName]="pageName"></app-bouton-quitter>
            <button id="btn-precedent" type="submit" name="BCPrecedent" value="Precedent" title="Precedent"
                class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile margin-left-5" (click)="clickPrecedent()"
                style="pointer-events: all; cursor: pointer;">
                Précédent
            </button>
            <span class="float-end">
                <button id="btn-suivant" type="submit" name="BCSuivant" value="Continuer" title="Continuer"
                    class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile" (click)="clickSuivant()"
                    style="pointer-events: all; cursor: pointer;"
                    [disabled]="!pageForm.valid">
                    Calculer
                </button>
            </span>
        </div>
    </div>

    <div class="row" *ngIf="isPageErreur" >
        <div class="col-sm-12 center-middle-block">
            <div class="alert alert-danger" role="alert" style="margin-top:10px">
                <span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
                Une erreur est survenue pendant le calcul des droits.
                <br/>
                Vous pouvez réessayer en cliquant de nouveau sur le bouton Calculer.
            </div>
        </div>
    </div>


</div>
